import request from "@/uilt/new-axios.js";
import serverConfig from "@/assets/global/serverConfig";

export const getOrganisationList = (data) => {
  return request.postJson(
    `/${serverConfig.msPersonnelService}/organisation/data/get`,
    data
  );
};
